export const buildMetadataEnhancer = () => ({
  env: process.env.NODE_ENV,
  buildId: process.env.NEXT_PUBLIC_BUILD_ID,
  commit: process.env.NEXT_PUBLIC_COMMIT_SHA,
});
